import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentClone = () => {
  return (
    <g>
      <path d="m4.94.005 5.013.012c.54.001.984.41 1.04.936l.007.114v1.94l3.953.01c.54.001.984.41 1.04.936l.007.114V14.95c0 .541-.41.987-.936 1.044L14.95 16h-8.9a1.05 1.05 0 0 1-1.044-.936L5 14.95V13H1.05a1.05 1.05 0 0 1-1.044-.936L0 11.95V4.94L4.94.004zm6.06 4.5v7.445c0 .541-.41.987-.936 1.044L9.95 13H6.5v1.5h8V4.514l-3.5-.01zm-5-3V4.95c0 .541-.41.987-.936 1.044L4.95 6H1.5v5.5h8V1.514L6 1.505zM4.5 2.565 2.562 4.5H4.5V2.563z" />
    </g>
  );
};

export default withIcon(IconDocumentClone);
